import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page35',
  templateUrl: './page35.component.html',
  styleUrls: ['./page35.component.css']
})
export class Page35Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
